import GridComponent from '../../../../../component/grid/GridComponent.component';
import { useFormik } from 'formik';
import FormLabel from '../../../../../component/input/FormLabel.component';
import Employee from '../interfaces/Employee';
import Grid from '@material-ui/core/Grid';
import Button from '../../../../../component/buttton/Button.component';
import { FormInput } from '../../../../../component/input/InputStyle';
import { FormInterface } from '../../../../../core/interfaces/form/Form';

export default function Form({ handleSubmitForm, initialValues }: FormInterface<Employee>) {

    const { values, handleSubmit, handleChange } = useFormik<Employee>({
        initialValues: initialValues,
        onSubmit: values => {
            handleSubmitForm(values);
        },
    });

    return (
        <form onSubmit={handleSubmit}>
            <GridComponent justify="flex-start" alignItems="flex-end" spacing={2} >
                <FormLabel title="Colaboradores" sm={9} md={10} >
                    <FormInput
                        name="Nome"
                        value={values.Nome}
                        onChange={handleChange}
                        required
                    />
                </FormLabel>
                <Grid item sm={3} md={2}>
                    <Button title="Pesquisar" size='medium' />
                </Grid>
            </GridComponent>
        </form>
    )
}